<div class="count-card">
    <h3 class="count-card-counter">{{ firstNumber }} / {{ secondNumber }}</h3>
    <h4 class="count-card-sub-title">{{ subTitle }}</h4>
</div>